/**
 * Training delivery routes — sessions and their rosters.
 * Mounted under /hr, so these resolve to /hr/trainingmanagement/sessions*.
 */
export const trainingDeliveryRoutes: any[] = [
  {
    path: 'trainingmanagement/sessions',
    name: 'trainingSessions',
    component: () => import('@/modules/hr/trainingmanagement/delivery/components/TrainingSessionList.vue'),
    meta: {
      title: 'routes.trainingSessions',
      requiresAuth: true,
      breadcrumb: 'Training Sessions',
    },
  },
  {
    path: 'trainingmanagement/sessions/:id/roster',
    name: 'trainingRoster',
    component: () => import('@/modules/hr/trainingmanagement/delivery/components/TrainingRoster.vue'),
    meta: {
      title: 'routes.trainingRoster',
      requiresAuth: true,
      breadcrumb: 'Session Roster',
    },
  },
]

export default trainingDeliveryRoutes
